import { useDebounce, useGetAppellationsAutocomplete } from "@api";
import type { IAutocompleteAppellation } from "@bbj-types/appellations";
import { type SyntheticEvent, useMemo, useState } from "react";

export type TAutocompleteAppellationsOption = IAutocompleteAppellation["matchedAppellations"][number] & {
  romeLabel: string;
  rome: string;
};

export const useAutocompleteAppellationsOptions = () => {
  const [{ data, loading }, getAppellations] = useGetAppellationsAutocomplete();
  const [textFieldValue, setTextFieldValue] = useState("");

  const options = useMemo(() => {
    const options: TAutocompleteAppellationsOption[] = [];
    if (data === undefined) {
      return options;
    }
    for (const rome of data) {
      for (const appellation of rome.matchedAppellations) {
        options.push({
          ...appellation,
          rome: rome.rome,
          romeLabel: rome.libelle,
        });
      }
    }
    return options;
  }, [data]);

  const handleInputDebounce = useDebounce(
    (value: string) => {
      setTextFieldValue(value);
      if (value.length >= 4) {
        getAppellations({ search: value });
      }
    },
    750,
    []
  );

  const handleInputChange = (_: SyntheticEvent, value: string) => {
    handleInputDebounce(value);
  };

  return { textFieldValue, options, loading, handleInputChange } as const;
};
